<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M19 37l19 -18h225l18 18v225l-18 19h-225l-19 -19v-225zM38 37v150h150v-150h-150zM206 37v225h57v-225h-57z"
    />
  </svg>
</template>
